import messages from './tag-messages.js';
export default [
    {tag: '端午节', intlLabel: messages.dragon_boat_festival},
    {tag: '元旦', intlLabel: messages.new_year},
    {tag: '圣诞节', intlLabel: messages.christmas},
    {tag: 'people', intlLabel: messages.people},
    {tag: 'transportation', intlLabel: messages.transportation},
    {tag: 'things', intlLabel: messages.things},
    {tag: 'animals', intlLabel: messages.animals},
    {tag: 'dress-up', intlLabel: messages.dress_up},
    {tag: 'city', intlLabel: messages.city},
    {tag: 'flying', intlLabel: messages.flying},
    {tag: 'fantasy', intlLabel: messages.fantasy},
    {tag: 'letters', intlLabel: messages.letters}
];
